import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Post from "../components/Post";

const Onepost = () => {
    const { id } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [onlineUsers, setOnlineUsers] = useState([]);

    useEffect(() => {
        const uid = localStorage.getItem("echo_user");
        if (!uid) return;

        const ping = async () => {
            try {
                const res = await fetch("https://api.fantasyworldtrpg.cz/echo/online.php", {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ uid })
                });

                const data = await res.json();
                if (data.success && Array.isArray(data.onlineUsers)) {
                    setOnlineUsers(data.onlineUsers);
                }
            } catch (err) {
                console.error("Chyba při pingnutí online:", err);
            }
        };

        ping();

        const interval = setInterval(ping, 30000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!id) return;

        const fetchPost = async () => {
            try {
                const res = await fetch('https://api.fantasyworldtrpg.cz/echo/onepost.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id }),
                });

                const data = await res.json();
                if (data.status === 'success') {
                    setPost(data.post);
                }
            } catch (err) {
                console.error('Chyba při načítání postu:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchPost();
    }, [id]);

    if (loading) return <div className="text-center my-5">⏳ Načítání příspěvku...</div>;
    if (!post) return <div className="text-center my-5 text-danger">❌ Příspěvek nenalezen</div>;

    return (
        <div className="container py-5 my-5">
            <Post
                key={post.id || id}
                post={post}
                onlineUsers={onlineUsers}
            />
        </div>
    );
};

export default Onepost;
